import React from 'react';
import { useInsightsHeroContent } from '../../../../hooks/useInsightsHeroContent';
import heroImage from '../../../../assets/images/insights/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useInsightsHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, titleLines, text, image } = content;

  return (
    <section className="insights-hero">
      <img
        className="insights-hero__bg"
        src={image || heroImage}
        alt=""
        aria-hidden="true"
      />
      <div className="insights-hero__overlay" />

      <div className="insights-hero__inner">
        <div className="insights-hero__content">
          {eyebrow ? <p className="insights-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="insights-hero__title">
            {titleLines.map((line, index) => (
              <React.Fragment key={line}>
                {index > 0 ? <br /> : null}
                {line}
              </React.Fragment>
            ))}
          </h1>
          {text ? <p className="insights-hero__text">{text}</p> : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
